import React from "react";
import { Card, CardContent, CardActions } from "@mui/material";
import imgSitenso from "../../assets/images/maqueta/Tensolite1.png";

function CardDownloadMultimedia({ multimedia }) {
  return multimedia?.filename?.map(
    (file, index) =>
      file?.deleted !== true && (
        <div className="card-downloads multimedia-card">
          <Card
            sx={{ marginBottom: 3 }}
            className="card-downloads__card width-multimedia card-mult"
            key={index}
          >
            <CardContent key={index} className="cards-style card-mult">
              <div>
                <img
                  className="img-card-producto"
                  src={imgSitenso}
                  alt={file?.title}
                />
                <article className="title-card-archivo">
                  <h4 id="title">
                    {file?.title} {multimedia?.name}
                  </h4>
                </article>
              </div>
            </CardContent>
            <CardActions className="actions card-mult">
              <button className="settings_button-pleno bg-p-primary_2 download-file-button">
                <a href={file?.url} rel="noreferrer">
                  Descargar
                </a>
              </button>
            </CardActions>
          </Card>
        </div>
      )
  );
}

export default CardDownloadMultimedia;
